import { CommonModule } from '@angular/common';
// Anglar
import { NgModule } from '@angular/core';
// Layout Directives
// Pipes
// Services
import { FirstLetterPipe, GetObjectPipe, JoinPipe, SafePipe, TimeElapsedPipe } from './_base/layout';

@NgModule({
  imports: [CommonModule],
  declarations: [
    // pipes
    TimeElapsedPipe,
    JoinPipe,
    GetObjectPipe,
    SafePipe,
    FirstLetterPipe
  ],
  exports: [
    // pipes
    TimeElapsedPipe,
    JoinPipe,
    GetObjectPipe,
    SafePipe,
    FirstLetterPipe
  ],
  providers: []
})
export class CoreModule {
}
